import { AnprVM } from 'shell/view-models/search-anpr';
import { AxiosResponse } from 'axios';
import { HttpResponse } from 'shell/models/http-response';
import { ResponseAnprData } from 'shell/models/person';
import { DateTime } from 'luxon';
import { StatementsFormVM } from 'front-office/view-models/statements/statements-form';

export const transformerPersonGeneralityDeceasedList = (
  response: AxiosResponse<HttpResponse<ResponseAnprData>>
): AnprVM<StatementsFormVM> => {
  return {
    warnings: (response.data.payload?.risposta3002OK?.listaAnomalie?.errore || []).map(
      (warning) => ({
        id: warning.codiceErroreAnomalia,
        value: warning.testoErroreAnomalia,
      })
    ),
    errors: (response.data.payload?.rispostaKO?.listaErrori?.errore || []).map((error) => ({
      id: error.codiceErroreAnomalia,
      value: error.testoErroreAnomalia,
    })),
    persons: (response.data.payload?.risposta3002OK?.listaSoggetti?.datiSoggetto || []).map(
      (person) => {
        const residenceArray = person.residenza || [];

        let birthplace = '';
        // birthplace check for object
        if (person.generalita?.luogoNascita?.localita) {
          birthplace = `${person.generalita?.luogoNascita?.localita.descrizioneLocalita} (${person.generalita?.luogoNascita?.localita.descrizioneStato})`;
        }

        if (person.generalita?.luogoNascita?.comune) {
          birthplace = `${person.generalita?.luogoNascita?.comune.nomeComune} (${person.generalita?.luogoNascita?.comune.siglaProvinciaIstat})`;
        }
        // Residence check for object
        let residence = '';
        // scelgo il primo o è un array?
        if (residenceArray[0]?.indirizzo) {
          residence = `${residenceArray[0]?.indirizzo.comune?.nomeComune || ''} (${
            residenceArray[0]?.indirizzo.comune?.siglaProvinciaIstat || ''
          })`;
        }
        // scelgo il primo o è un array?
        if (residenceArray[0]?.localitaEstera) {
          residence = `${residenceArray[0]?.localitaEstera.indirizzoEstero?.localita?.descrizioneLocalita} (${residenceArray[0]?.localitaEstera.indirizzoEstero?.localita?.descrizioneStato})`;
        }

        let state = '';
        // state check for object
        if (residenceArray[0]?.indirizzo?.toponimo) {
          const toponym = residenceArray[0]?.indirizzo?.toponimo;

          const civic = residenceArray[0]?.indirizzo?.numeroCivico;

          state = `${toponym.specie || ''} ${toponym?.denominazioneToponimo || ''},${
            civic?.numero || ''
          }${civic?.esponente1 ? `/${civic.esponente1}${civic.lettera || ''}` : ''}`;
        }

        if (person.generalita?.soggettoAIRE && person.generalita?.soggettoAIRE === 'S') {
          state = 'Iscritto AIRE';
        }

        if (person.datiCancellazione && person.datiCancellazione?.descrizioneMotivoCancellazione) {
          state = `${person.datiCancellazione.descrizioneMotivoCancellazione}`;
        }

        return {
          decased: {
            fiscalCode: person.generalita?.codiceFiscale?.codFiscale,
            name: person.generalita?.nome,
            surname: person.generalita?.cognome,
            withoutName: person.generalita?.senzaNome === '1' ? true : false,
            withoutSurname: person.generalita?.senzaCognome === '1' ? true : false,
            gender: person.generalita?.sesso,
            birthplace,
            state,
            residenceString: residence,
            idSubjectAnpr: person.generalita?.idSchedaSoggettoANPR,
            dateBirth: person.generalita?.dataNascita
              ? DateTime.fromISO(person.generalita?.dataNascita)
              : null,
            dateDeath: person.datiDecesso?.dataEvento
              ? DateTime.fromISO(person.datiDecesso?.dataEvento)
              : null,
            dateMarriage: person.matrimonio?.datiMatrimonio?.dataEvento
              ? DateTime.fromISO(person.matrimonio.datiMatrimonio?.dataEvento)
              : null,
            municipalityOfBirth:
              person.generalita?.luogoNascita?.comune || person.generalita?.luogoNascita?.localita
                ? {
                    id:
                      person.generalita?.luogoNascita?.comune?.codiceIstat ||
                      person.generalita?.luogoNascita?.localita?.descrizioneLocalita,
                    description:
                      person.generalita?.luogoNascita?.comune?.nomeComune ||
                      person.generalita?.luogoNascita?.localita?.descrizioneLocalita,
                    province:
                      person.generalita?.luogoNascita?.comune?.siglaProvinciaIstat ||
                      person.generalita?.luogoNascita?.localita?.provinciaContea,
                  }
                : null,
            foreignStateBirth: person.generalita?.luogoNascita?.localita?.codiceStato
              ? {
                  id: person.generalita?.luogoNascita?.localita?.codiceStato,
                  value: person.generalita?.luogoNascita?.localita?.descrizioneStato,
                  istatCode: person.generalita?.luogoNascita?.localita?.codiceStato,
                }
              : undefined,
            isBirthStateItalian: Boolean(person.generalita?.luogoNascita?.localita?.codiceStato),
            municipalityOfDeath:
              person.datiDecesso?.luogoEvento?.comune || person.datiDecesso?.luogoEvento?.localita
                ? {
                    id:
                      person.datiDecesso?.luogoEvento?.comune?.codiceIstat ||
                      person.datiDecesso?.luogoEvento?.localita?.descrizioneLocalita,
                    description:
                      person.datiDecesso?.luogoEvento?.comune?.nomeComune ||
                      person.datiDecesso?.luogoEvento?.localita?.descrizioneLocalita,
                    province:
                      person.datiDecesso?.luogoEvento?.comune?.siglaProvinciaIstat ||
                      person.datiDecesso?.luogoEvento?.localita?.provinciaContea,
                  }
                : null,
            foreignStateOfDeath: person.datiDecesso?.luogoEvento?.localita?.codiceStato
              ? {
                  id: person.datiDecesso?.luogoEvento?.localita?.codiceStato,
                  value: person.datiDecesso?.luogoEvento?.localita?.descrizioneStato,
                  istatCode: person.datiDecesso?.luogoEvento?.localita?.codiceStato,
                }
              : undefined,
            isDeathStateItalian: Boolean(person.datiDecesso?.luogoEvento?.localita?.codiceStato),
            municipalityOfMarriage:
              person.matrimonio?.datiMatrimonio?.luogoEvento?.comune ||
              person.matrimonio?.datiMatrimonio?.luogoEvento?.localita
                ? {
                    id:
                      person.matrimonio?.datiMatrimonio?.luogoEvento?.comune?.codiceIstat ||
                      person.matrimonio?.datiMatrimonio?.luogoEvento?.localita?.descrizioneLocalita,
                    description:
                      person.matrimonio?.datiMatrimonio?.luogoEvento?.comune?.nomeComune ||
                      person.matrimonio?.datiMatrimonio?.luogoEvento?.localita?.descrizioneLocalita,
                    province:
                      person.matrimonio?.datiMatrimonio?.luogoEvento?.comune?.siglaProvinciaIstat ||
                      person.matrimonio?.datiMatrimonio?.luogoEvento?.localita?.provinciaContea,
                  }
                : null,
            foreignStateOfMarriage: person.matrimonio?.datiMatrimonio?.luogoEvento?.localita
              ?.codiceStato
              ? {
                  id: person.matrimonio?.datiMatrimonio?.luogoEvento?.localita?.codiceStato,
                  value: person.matrimonio?.datiMatrimonio?.luogoEvento?.localita?.descrizioneStato,
                  istatCode: person.matrimonio?.datiMatrimonio?.luogoEvento?.localita?.codiceStato,
                }
              : undefined,
            isMarriageStateItalian: Boolean(
              person.matrimonio?.datiMatrimonio?.luogoEvento?.localita?.codiceStato
            ),
          },
          hidden: {
            delete: true,
            edit: true,
          },
        };
      }
    ) as Array<StatementsFormVM>,
  };
};
